export function envCOMMIT_HASH(): string | undefined {
    return process.env.REACT_APP_COMMIT_HASH;
}
